import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import GenderForm from '../../../components/forms/GenderForm';
import { useCreateGender } from '../../../hooks/useGenderApi';
import { useNavigate } from 'react-router-dom';
import { GenderDTO } from '../../../services/apiClient';

const GenderCreate: React.FC = () => {
  const createGender = useCreateGender();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Genders', href: '/admin/genders' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: GenderDTO) => {
    try {
      await createGender.mutateAsync(data);
      navigate('/admin/genders');
    } catch (error) {
      console.error('Error creating Gender:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/genders"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Gender.Edit'
    >
        <GenderForm
          initialValues={{} as GenderDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/genders')}
        />
    </AdminLayout>
  );
};

export default GenderCreate;